export default "__VITE_ASSET__Ekk_1_$c__"